import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusRefunded = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Remboursement</title>
        <path
          d="M2.69652 10.08C2.75652 5.64001 6.04652 2.04001 10.0965 2.04001C11.6465 2.04001 13.1765 2.59001 14.4265 3.59001C14.6165 3.74001 14.6565 4.03001 14.5065 4.23001L14.1965 4.64001C14.0665 4.82001 13.8265 4.86001 13.6565 4.72001C12.6265 3.90001 11.3665 3.45001 10.0865 3.45001C6.97652 3.45001 4.40652 6.02001 4.02652 9.32001L4.76652 8.56001C4.90652 8.41001 5.13652 8.53001 5.12652 8.74001L4.87652 14.33C4.87652 14.54 4.63652 14.63 4.50652 14.48L1.05652 10.39C0.926521 10.23 1.03652 9.98001 1.22652 9.99001L2.70652 10.07L2.69652 10.08Z"
          fill="#4EAE36"
        />
        <path
          d="M10.0965 16.94C13.2065 16.94 15.7765 14.37 16.1565 11.07L15.4165 11.83C15.2765 11.98 15.0465 11.86 15.0565 11.65L15.3065 6.06001C15.3065 5.85001 15.5465 5.76001 15.6765 5.91001L19.1365 10.01C19.2665 10.17 19.1565 10.42 18.9665 10.41L17.4865 10.33C17.4265 14.77 14.1365 18.37 10.0865 18.37C8.53653 18.37 7.00653 17.82 5.75653 16.83C5.56653 16.68 5.52653 16.39 5.67653 16.19L5.98653 15.78C6.11653 15.6 6.35653 15.56 6.52653 15.7C7.55653 16.52 8.81653 16.97 10.0965 16.97V16.94Z"
          fill="#4EAE36"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusRefunded;
